import { InlandMarineTypes, FarmRiskType, lookupsJson, FarmScheduleCoverageType } from '@ourbranch/lookups';
const { deductibleAllOther: allOtherOptions, scheduledFarmPropertyCategories } = lookupsJson.farm;
const dwellingInlandMarineItemTypes = [
    InlandMarineTypes.Atv,
    InlandMarineTypes.BoatDock,
    InlandMarineTypes.Boats,
    InlandMarineTypes.CoinCollection,
    InlandMarineTypes.FineArts,
    InlandMarineTypes.Furs,
    InlandMarineTypes.GardenTractors,
    InlandMarineTypes.GolfCarts,
    InlandMarineTypes.GolfEquipment,
    InlandMarineTypes.Guns,
    InlandMarineTypes.Jewelry,
    InlandMarineTypes.LawnMowers,
    InlandMarineTypes.MiscellaneousProperty,
    InlandMarineTypes.MusicalInstruments,
    InlandMarineTypes.PersonalTools,
    InlandMarineTypes.Silverware,
    InlandMarineTypes.SportingEquipment,
    InlandMarineTypes.Tack,
    InlandMarineTypes.UnmannedAircraft
].sort((a, b) => a.id.localeCompare(b.id));
const brand = {
    constants: {
        SHORT_NAME: 'CFM',
        FULL_NAME: 'CFM Insurance',
        LEGAL_NAME: 'CFM Insurance, Inc',
        EMAIL_SENDER: 'CFM Insurance',
        EMAIL_BCC: 'info@cfmimo.com',
        SUPPORT_NAME: 'CFM Insurance',
        DOMAIN: 'cfmimo.com',
        SUPPORT_EMAIL: 'info@cfmimo.com',
        DISPLAY_NAME: 'CFM',
        MARKETING_NAME: 'CFM Insurance',
        POLICY_ISSUER: 'CFM Insurance',
        CLAIMS_HANDLER: 'CFM',
        REFERRAL_NAME: 'CFM Insurance',
        SOCIAL_HANDLE: 'CFM',
        PAYMENT_ADDRESS: 'CFM Insurance, Inc PO Box 968 1202 SE 1st Street Concordia',
        EXPEDITED_PAYMENT_ADDRESS: 'CFM Insurance, Inc PO Box 968 1202 SE 1st Street Concordia',
        CUSTOMER_SERVICE_PHONE: '800-218-2223',
        CUSTOMER_SERVICE_PHONE_LETTERS: '800-218-2223'
    },
    config: {
        farm: {
            IL: {
                [FarmRiskType.Fo1]: {
                    hiddenCoverages: ['inflationGuard', 'earthquakeCoverage'],
                    customFormComponentPaths: {
                        cosmeticDamageExclusionSection: 'base/cosmetic-damage-exclusion-section',
                        deductibleAllOther: 'base/deductible-all-other',
                        deductibleWindHail: 'base/deductible-wind-hail',
                        roofLossSettlement: 'FO1/roof-loss-settlement',
                        repairRebuildRequirement: 'base/repair-rebuild-requirement',
                        coverageMS: 'base/coverage-ms',
                        coverageB: 'base/coverage-b',
                        lossSettlement: 'FO1/loss-settlement',
                        personalPropertyReplCost: 'FO1/personal-property-repl-cost'
                    },
                    inlandMarine: {
                        itemTypes: dwellingInlandMarineItemTypes,
                        deductibleAllOtherOptions: allOtherOptions.filter((option) => [250, 500, 1000, 2500, 5000].includes(option.id))
                    }
                },
                [FarmRiskType.Fo2]: {
                    hiddenCoverages: ['earthquakeCoverage'],
                    customFormComponentPaths: {
                        cosmeticDamageExclusionSection: 'base/cosmetic-damage-exclusion-section',
                        deductibleAllOther: 'base/deductible-all-other',
                        deductibleWindHail: 'base/deductible-wind-hail',
                        inflationGuard: 'base/inflation-guard',
                        coverageB: 'base/coverage-b',
                        repairRebuildRequirement: 'base/repair-rebuild-requirement',
                        coverageMS: 'base/coverage-ms',
                        roofLossSettlement: 'FO2/roof-loss-settlement',
                        coverageD: 'FO2/coverage-d'
                    },
                    inlandMarine: {
                        itemTypes: dwellingInlandMarineItemTypes,
                        deductibleAllOtherOptions: allOtherOptions.filter((option) => [250, 500, 1000, 2500, 5000].includes(option.id))
                    }
                },
                [FarmRiskType.Fo3]: {
                    hiddenCoverages: [
                        'earthquakeCoverage',
                        'expandedDebrisRemoval',
                        'businessProperty',
                        'sprinklerLeakage',
                        // unscheduled personal property
                        'moneyLimit',
                        'jewelryLimit',
                        'securitiesLimit',
                        'motorizedVehiclesLimit',
                        'silverwareLimit',
                        'gunsLimit',
                        'businessPropertyLimit',
                        'inlandFlood'
                    ],
                    customFormComponentPaths: {
                        deductibleAllOther: 'base/deductible-all-other',
                        deductibleWindHail: 'base/deductible-wind-hail',
                        roofLossSettlement: 'base/roof-loss-settlement',
                        inflationGuard: 'base/inflation-guard',
                        repairRebuildRequirement: 'base/repair-rebuild-requirement',
                        coverageB: 'base/coverage-b',
                        coverageMS: 'base/coverage-ms',
                        coverageD: 'FO3/coverage-d',
                        cosmeticDamageExclusionSection: 'base/cosmetic-damage-exclusion-section',
                        repairRebuildRequirementCalled: 'FO3/repair-rebuild-requirement',
                        personalPropertyReplCost: 'FO3/personal-property-repl-cost',
                        lossSettlement: 'FO3/loss-settlement'
                    },
                    inlandMarine: {
                        itemTypes: dwellingInlandMarineItemTypes,
                        deductibleAllOtherOptions: allOtherOptions.filter((option) => [250, 500, 1000, 2500, 5000].includes(option.id))
                    }
                },
                [FarmRiskType.Fo4]: {
                    hiddenCoverages: [
                        'deductibleEarthquake',
                        'earthquakeCoverage',
                        'expandedDebrisRemoval',
                        'moneyLimit',
                        'jewelryLimit',
                        'securitiesLimit',
                        'motorizedVehiclesLimit',
                        'silverwareLimit',
                        'gunsLimit',
                        'businessPropertyLimit',
                        'mineSubsidenceCoverage',
                        'inlandFloodCoverage'
                    ],
                    inlandMarine: {
                        itemTypes: dwellingInlandMarineItemTypes,
                        deductibleAllOtherOptions: allOtherOptions.filter((option) => [250, 500, 1000, 2500, 5000].includes(option.id))
                    },
                    customFormComponentPaths: {
                        deductibleAllOther: 'base/deductible-all-other',
                        deductibleWindHail: 'base/deductible-wind-hail'
                    }
                },
                [FarmRiskType.Fo6Scheduled]: {
                    hiddenCoverages: ['earthquakeCoverage', 'deductibleEarthquake'],
                    coverageF: {
                        itemTypes: scheduledFarmPropertyCategories.filter((option) => !['10', '11', '12', '13', '14'].includes(option.id))
                    },
                    peakSeason: {
                        itemTypes: scheduledFarmPropertyCategories.filter((option) => ['4', '5', '14'].includes(option.id))
                    },
                    availableScheduledCoverageTypes: [FarmScheduleCoverageType.PEAK, FarmScheduleCoverageType.INCOME],
                    customFormComponentPaths: {}
                },
                [FarmRiskType.Fo6Unscheduled]: {
                    hiddenCoverages: ['earthquakeCoverage', 'deductibleEarthquake'],
                    customFormComponentPaths: {}
                },
                [FarmRiskType.Fo6Structures]: {
                    hiddenCoverages: ['earthquakeCoverage', 'deductibleEarthquake', 'hasEarthquakeExteriorVeneerCoverage'],
                    inlandMarine: {
                        itemTypes: dwellingInlandMarineItemTypes,
                        deductibleAllOtherOptions: allOtherOptions.filter((option) => [250, 500, 1000, 2500, 5000].includes(option.id))
                    },
                    customFormComponentPaths: {}
                }
            }
        }
    }
};
export const constants = brand.constants;
export default brand.config;
